import dynamic from 'next/dynamic';

export const MarketingAutoOpen = dynamic(() => import('./MarketingAutoOpen'), {
  ssr: false,
});
